// Round J/L — geldt een memo overal, of hoort hij bij één locatie?
export const SCOPE_ALL = "all";
export const SCOPE_SITE = "site";
export const ONLY_ALL_LABEL = "Alleen wat overal geldt";

export function effectiveScope(item) {
  if (item?.scope === SCOPE_ALL || item?.scope === SCOPE_SITE) return item.scope;
  return (item?.user_location || "").trim() ? SCOPE_SITE : SCOPE_ALL;
}

export function scopeLabel(item) {
  if (effectiveScope(item) === SCOPE_ALL) return "Geldt overal";
  const site = (item?.user_location || "").trim();
  return site ? `Alleen ${site}` : "Alleen op één locatie";
}

export function matchesScope(item, onlyAll) {
  return !onlyAll || effectiveScope(item) === SCOPE_ALL;
}

export function otherScope(item) {
  return effectiveScope(item) === SCOPE_ALL ? SCOPE_SITE : SCOPE_ALL;
}

// Round L — a person's own locations, in order (the first is the default).
export function ownLocations(user) {
  const list = Array.isArray(user?.locations) && user.locations.length ? user.locations : [user?.location];
  return list.filter((s) => typeof s === "string" && s.trim());
}

// Round L — the picker: "Geldt overal" plus one entry per location. The speaker sees his own ACTIVE
// locations; an admin sees every active location, the counting ones first. `activeLocations` null =
// not loaded yet: the admin then gets no generic fallback, the speaker his own list unfiltered.
export function scopeOptions(viewer, activeLocations = []) {
  const all = { key: "all", label: "Geldt overal", body: { scope: SCOPE_ALL } };
  const loaded = Array.isArray(activeLocations);
  const act = (loaded ? activeLocations : []).filter((l) => l && l.name);
  let names;
  if (viewer?.role === "admin") {
    if (!loaded) return [all];
    names = [...act.filter((l) => l.counts_for_coverage !== false), ...act.filter((l) => l.counts_for_coverage === false)]
      .map((l) => l.name);
  } else {
    const activeLc = new Set(act.map((l) => l.name.toLowerCase()));
    names = ownLocations(viewer).filter((n) => !loaded || !act.length || activeLc.has(n.toLowerCase()));
  }
  const sites = names.map((n) => ({ key: `site:${n}`, label: `Alleen ${n}`, site: n, body: { scope: SCOPE_SITE, site: n } }));
  return sites.length ? [all, ...sites] : [all, { key: "site", label: "Alleen op één locatie", body: { scope: SCOPE_SITE } }];
}

export function isCurrentOption(item, option) {
  const scope = effectiveScope(item);
  if (option.key === "all") return scope === SCOPE_ALL;
  const site = (item?.user_location || "").trim().toLowerCase();
  if (!option.site) return scope === SCOPE_SITE && !site;
  return scope === SCOPE_SITE && site === option.site.toLowerCase();
}
